import Badge from '@atlaskit/badge';
import FilterIcon from '@atlaskit/icon/glyph/filter';
import { Inline, xcss } from '@atlaskit/primitives';
import Pressable from '@atlaskit/primitives/pressable';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const buttonStyles = xcss({
  width: '100%',
  borderRadius: 'radius.large',
  height: 'size.400',
  backgroundColor: 'color.background.neutral',
  color: 'color.text',
  fontSize: '0.875rem',
  fontWeight: 500,
  ':hover': {
    backgroundColor: 'color.background.neutral.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.neutral.pressed'
  }
});
const buttonSelectedStyles = xcss({
  backgroundColor: 'color.background.selected',
  color: 'color.text.selected',
  ':hover': {
    backgroundColor: 'color.background.selected.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.selected.pressed'
  }
});
export const ShowFiltersButton = _ref => {
  let {
    numberOfSelections,
    onClick,
    enableSort = false
  } = _ref;
  return /*#__PURE__*/_jsx(Pressable, {
    onClick: onClick,
    xcss: [buttonStyles, numberOfSelections > 0 && buttonSelectedStyles],
    children: /*#__PURE__*/_jsxs(Inline, {
      alignInline: "center",
      alignBlock: "center",
      space: "space.050",
      children: [/*#__PURE__*/_jsx(FilterIcon, {
        label: ""
      }), enableSort ? 'Sort & filter' : 'Filter', numberOfSelections > 0 && /*#__PURE__*/_jsx(Badge, {
        appearance: "primary",
        children: numberOfSelections
      })]
    })
  });
};